/**
 * Máscara para CEP: 00000-000
 * Não aceita letras ou outros caracteres – apenas dígitos, max 8.
 */

import { CEP_TAMANHO } from "../../domain/validators/terceiros.constantes.js";
import { sanitizarCep } from "../../domain/rules/normalizadores.js";

export { sanitizarCep };

/**
 * Sanitiza CEP: só dígitos.
 * Remove letras e outros caracteres.
 * @param {*} valor
 * @returns {string}
 */
/**
 * Sanitiza CEP para máscara (bloqueia além do limite).
 * @param {*} valor
 * @returns {string}
 */
export function sanitizarCepParaMascara(valor) {
  return sanitizarCep(valor).slice(0, CEP_TAMANHO);
}

/**
 * Aplica máscara incremental CEP.
 * @param {*} valor
 * @returns {string}
 */
export function aplicarMascaraCep(valor) {
  const raw = sanitizarCepParaMascara(valor);
  if (!raw) return "";
  if (raw.length <= 5) return raw;
  return `${raw.slice(0, 5)}-${raw.slice(5, 8)}`;
}

/**
 * Remove máscara.
 * @param {*} valor
 * @returns {string}
 */
export function removerMascaraCep(valor) {
  return sanitizarCep(valor);
}
